/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePromoBannerFragment, PromoBannerFragment, FullPromoBannerFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner';

/**
 * Get a single PromoBanner by ID (base - scalars only)
 */
export const getBasePromoBannerById = gql`
  ${BasePromoBannerFragment}

  query GetBasePromoBannerById($id: String!, $locale: String!, $preview: Boolean) {
    promoBanner(id: $id, locale: $locale, preview: $preview) {
      ...BasePromoBannerFragment
    }
  }
`;

/**
 * Get a single PromoBanner by ID (standard - 1 level deep)
 */
export const getPromoBannerById = gql`
  ${PromoBannerFragment}

  query GetPromoBannerById($id: String!, $locale: String!, $preview: Boolean) {
    promoBanner(id: $id, locale: $locale, preview: $preview) {
      ...PromoBannerFragment
    }
  }
`;

/**
 * Get a single PromoBanner by ID (full - 2 levels deep)
 */
export const getFullPromoBannerById = gql`
  ${FullPromoBannerFragment}

  query GetFullPromoBannerById($id: String!, $locale: String!, $preview: Boolean) {
    promoBanner(id: $id, locale: $locale, preview: $preview) {
      ...FullPromoBannerFragment
    }
  }
`;

/**
 * Get all PromoBanner entries with pagination (base - scalars only)
 */
export const getBasePromoBanners = gql`
  ${BasePromoBannerFragment}

  query GetBasePromoBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerOrder]
    $where: PromoBannerFilter
    $preview: Boolean
  ) {
    promoBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePromoBannerFragment
      }
    }
  }
`;

/**
 * Get all PromoBanner entries with pagination (standard - 1 level deep)
 */
export const getPromoBanners = gql`
  ${PromoBannerFragment}

  query GetPromoBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerOrder]
    $where: PromoBannerFilter
    $preview: Boolean
  ) {
    promoBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...PromoBannerFragment
      }
    }
  }
`;

/**
 * Get all PromoBanner entries with pagination (full - 2 levels deep)
 */
export const getFullPromoBanners = gql`
  ${FullPromoBannerFragment}

  query GetFullPromoBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerOrder]
    $where: PromoBannerFilter
    $preview: Boolean
  ) {
    promoBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullPromoBannerFragment
      }
    }
  }
`;
